"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useScrollOutsideHandler(ref, elementRef, handler) {
    (0, react_1.useEffect)(() => {
        function scrollOutside(event) {
            if (ref.current &&
                !ref.current.contains(event.target) &&
                elementRef.current &&
                !elementRef.current.contains(event.target)) {
                handler();
            }
        }
        document.addEventListener('scroll', scrollOutside, true);
        return () => {
            document.removeEventListener('scroll', scrollOutside);
        };
    }, [ref]);
}
exports.default = useScrollOutsideHandler;
